import { LegacyDataCollection } from '../types';

export const taxLegacyData: LegacyDataCollection = {
  type: 'tax',
  name: 'Skatt',
  categories: [
    {
      id: 'tax-category1',
      name: 'Fåmansföretag',
      image: 'gt/image/go_beyond/001.jpg',
      items: [
        {
          id: 'tax-category1-1',
          name: 'Ändrade basbelopp m.m.',
          image: 'gt/image/go_beyond/002.jpg',
          content: [
            {
              type: 'description',
              value:
                'Högre basbelopp och därmed bl.a. högre gränsbelopp till ägare av fåmansföretag',
            },
            {
              type: 'subheading',
              value: 'Exempel på höjningar',
            },
            {
              type: 'list-item',
              value:
                'Det förhöjda prisbasbeloppet har för 2025 höjts från 58 800 kr till 60 000 kr',
            },
            {
              type: 'list-item',
              value:
                'Inkomstbasbeloppet för 2024 är 76 200 kr, IBB för 2025 är 80 600 kr',
            },
            {
              type: 'list-item',
              value:
                'Gränsbelopp enligt schablonregeln Inkomstår 2025: 209 550 kr (baseras på 2024 års IBB).',
            },
            {
              type: 'subheading',
              value: 'Några effekter',
            },
            {
              type: 'tag',
              // tslint:disable-next-line:max-line-length
              value:
                'Grundavdraget och jobbskatteavdraget höjs vilket innebär sänkt skatt på arbetsinkomst och pension',
            },
            {
              type: 'tag',
              value: 'SGI och taket för föräldraförsäkring höjs',
            },
            {
              type: 'tag',
              value:
                'OBS: Skiktgränsen för statlig inkomstskattuppgår till 625 800 kr för inkomståret 2025.',
            },
          ],
        },
        {
          id: 'tax-category1-2',
          name: '3:12-regler - Trendspaning',
          image: 'gt/image/go_beyond/003.jpg',
          content: [
            {
              type: 'description',
              // tslint:disable-next-line:max-line-length
              value:
                'I samband med riksdagens beslut om budgeten så antogs nya regler för fåmansföretag som gäller från 1 januari 2026.',
            },
            {
              type: 'subheading',
              value: 'De nya 3:12-reglerna',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'Förenklingsregeln och huvudregeln slås ihop till en regel',
            },
            {
              type: 'list-item',
              value:
                'Grundbeloppet höjs från 2,75 IBB till 4 IBB per år (fördelas per individ och ägd andel av respektive bolag. Max 4 IBB per individ.',
            },
            {
              type: 'list-item',
              value:
                'Delägare som äger andelar i flera bolag ska fördela grundbeloppet proportioneligt mellan bolagen vilket medför att det det kan bli mer fördelaktigt att samla alla äganden under ett bolag. Inte längre möjligt att välja för vilka aktier man använder grundbelopppet.',
            },
            {
              type: 'list-item',
              value: 'Kapitalandelskravet/4 procentspärren slopas.',
            },
            {
              type: 'list-item',
              value:
                'Löneuttagskravet tas bort men ersätts med ett löneavdrag om 8 IBB.',
            },
            {
              type: 'list-item',
              value:
                'Återgång till civilrättslig dotterbolagsdefionition för aktiebolag vid beräkning av löneunderlag.',
            },
            {
              type: 'list-item',
              value:
                'Karenstiden förkortas från 5 till 4 år för övergången till okvalificerade andelar.',
            },
            {
              type: 'list-item',
              value: 'Inga förändrade skattesatser.',
            },
            {
              type: 'list-item',
              value:
                'Ingen förändrad närståendedefinition - syskon ses fortsatt som närstående.',
            },
            {
              type: 'tag',
              value:
                'Viktigt med rätt löner och struktur redan under 2025 för att få med sig rätt belopp in till 2026. ',
            },
            {
              type: 'tag',
              value:
                'Viktigare än tidigare att bedöma och ha koll på delägarens samtliga kvalificerade aktier när deklarationen upprättas, då det påverkar fördelningen av grundbeloppet.',
            },
          ],
        },
        {
          id: 'tax-category1-3',
          name: 'Carried interest-utredningen',
          image: 'gt/image/go_beyond/004.jpg',
          content: [
            {
              type: 'description',
              value:
                'Carried-interest utredningen presenterades den 28 januari 2025.',
            },
            {
              type: 'subheading',
              value: 'Förslaget',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'Enligt utredningens förslag ska personer med rätt till carried interest från en alternativ investeringsfond omfattas av fåmansföretagsreglerna. Reglerna som föreslås är restriktiva mot riskkapitalisterna.',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'Fondägarna föreslås bl.a. inte få tillgodogöra sig löneunderlaget i dotterföretag till den alternativa investeringsfonden.',
            },
            {
              type: 'list-item',
              value: 'Särskild karenstid på 10 år',
            },
            {
              type: 'list-item',
              value: 'Takbelopp i tjänst på 150 IBB',
            },
          ],
        },
        {
          id: 'tax-category1-4',
          name: 'Kvalificerade personaloptioner',
          image: 'gt/image/go_beyond/005.jpg',
          content: [
            {
              type: 'description',
              value:
                'Fortsatt ett väldigt skatteförmånligt incitamentsprogram som passar yngre och växande företag.',
            },
            {
              type: 'subheading',
              value: 'När kan det användas?',
            },
            {
              type: 'paragraph',
              value: 'Vissa villkor ska vara uppfyllda, bl.a.',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'Medelantalet anställda är lägre än 150, nettoomsättning eller balansomslutningen är högst 280 mkr',
            },
            {
              type: 'list-item',
              value:
                'Styrelseledamöter och suppleanter omfattas också av reglerna',
            },
            {
              type: 'list-item',
              value: 'Kan avse andel eller teckningsoption?',
            },
            {
              type: 'list-item',
              value: 'Option kan ges för ett annat bolag i koncernen',
            },
            {
              type: 'subheading',
              value: 'Nyheter',
            },
            {
              type: 'list-item',
              value:
                'Förändringar i regelverket gäller fr.o.m. 1 januari 2022.',
            },
            {
              type: 'list-item',
              value:
                'Inga större förändringar föreslås i 3:12-utredningen som har direkt påverkan på KPO.',
            },
            {
              type: 'subheading',
              value: 'Skattemässig sammanfattning av KPO',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'Innebär i korthet att en anställd som erhållit en personaloption av sin arbetsgivare i vissa fall inte beskattas i inkomstslaget tjänst när optionen utnyttjas för att förvärva aktier, samt att arbetsgivaren inte heller ska betala några arbetsgivaravgifter med anledning av nyttjandet.',
            },
            {
              type: 'subheading',
              value: 'Fördelen med KPO',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'KPO har gett nystartade företag en möjlighet att erbjuda anställda och styrelsen optioner och i förlängningen ett delägarskap utan att behöva betala mer än kvotvärdet.',
            },
          ],
        },
        {
          id: 'tax-category1-5',
          name: 'Låneförbudet',
          image: 'gt/image/go_beyond/006.jpg',
          content: [
            {
              type: 'description',
              // tslint:disable-next-line:max-line-length
              value:
                'Ett AB får inte lämna lån (eller ställa säkerhet) till person i den förbjudna kretsen. Ett AB får inte ge lån eller förskott (eller ställa säkerhet) i syfte att gäldenären ska förvärva aktier i bolaget eller i ett överordnat bolag.',
            },
            {
              type: 'subheading',
              value: 'Observera',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value: 'Hård bedömning av vad som är kommersiella lån, tex ej',
            },
            {
              type: 'list-subitem',
              value: 'Om lånet används för att starta ny verksamhet.',
            },
            {
              type: 'list-subitem',
              value: 'Ej endast marknadsmässig ränta.',
            },
            {
              type: 'list-item',
              value: 'Dispens medges ibland efter ansökan hos Skatteverket.',
            },
            {
              type: 'subheading',
              value: 'Det generella låneförbudet',
            },
            {
              type: 'list-item',
              value:
                'Ett aktiebolag får inte lämna lån (eller ställa säkerhet) till person i den sk. förbjudna kretsen.',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'I den förbjudna kretsen ingår den som äger aktier i bolaget eller bolag i samma koncern, samt styrelsemedlem eller vd. Även närstående ingår.',
            },
            {
              type: 'list-item',
              value: 'Undantag: Koncernlån. Även kommersiella lån är ok.',
            },
            {
              type: 'subheading',
              value: 'Förvärvslåneförbudet',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'Ett aktiebolag får inte ge lån eller förskott (eller ställa säkerhet) i syfte att gäldenären ska förvärva aktier i bolaget eller i ett överordnat bolag.',
            },
            {
              type: 'list-item',
              value:
                'Spelar ingen roll om låntagaren tillhör den förbjudna kretsen eller ej.',
            },
            {
              type: 'list-item',
              value: 'Finns inga särskilda undantag från förvärvslåneförbudet.',
            },
          ],
        },
      ],
    },
    {
      id: 'tax-category2',
      name: 'Företagsbeskattning',
      image: 'gt/image/go_beyond/007.jpg',
      items: [
        {
          id: 'tax-category2-1',
          name: 'Ränteavdrag N9 (Förslag)',
          image: 'gt/image/go_beyond/008.jpg',
          content: [
            {
              type: 'description',
              // tslint:disable-next-line:max-line-length
              value:
                'Den 31 maj 2024 presenterades förslaget ”Förbättrade ränteavdragsregler för företag” och förslaget föreslås träda i kraft den 1 januari 2026',
            },
            {
              type: 'subheading',
              value: 'Vilka företag ska lämna in N9-blankett?',
            },
            {
              type: 'list-item',
              value:
                'Företag som tillämpar huvudregeln (30 % av skattemässigt EBITDA)',
            },
            {
              type: 'list-item',
              value: 'Företag som nyttjar koncernkvittning',
            },
            {
              type: 'list-item',
              value: 'Företag som gör avdrag för kvarstående räntenetton',
            },
            {
              type: 'list-item',
              value: 'Företag som tillämpar förenklingsregeln, om:',
            },
            {
              type: 'list-subitem',
              value: 'Ingår i en intressegemenskap, eller',
            },
            {
              type: 'list-subitem',
              value:
                'Negativt räntenetto överstiger 5 mkr (förväntas höjas till 25 mkr 2026)',
            },
            {
              type: 'subheading',
              value: 'Utredningens förslag',
            },
            {
              type: 'list-item',
              value:
                'Beloppsgränsen för avdrag enligt förenklingsregeln höjs från 5 mkr kr till 25 mkr.',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'Avdragsrätten för ränta enligt huvudregeln (EBITDA) ska beräknas utan hänsyn till lämnade och mottagna koncernbidrag.',
            },
            {
              type: 'list-item',
              value:
                'Nytt beräkningssätt av avdragsunderlag samt räntenetto föreslås.',
            },
            {
              type: 'list-item',
              value: 'Nytt begrepp: ackumulerat räntenetto',
            },
            {
              type: 'list-item',
              value:
                'Tidsgränsen för möjligheten att dra av kvarstående negativa räntenetton slopas.',
            },
            {
              type: 'list-item',
              value:
                'Alla bolag i en intressegemenskap måste tillämpa samma regel (dvs. huvudregeln eller förenklingsregeln).',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'De riktade ränteavdragsreglerna ändras vad gäller avdrag för ränteutgifter vid interna förvärv av delägarrätter. Avdrag tillåts endast om förvärvet har ett direkt samband med och är orsakat av ett externt förvärv.',
            },
            {
              type: 'list-item',
              // tslint:disable-next-line:max-line-length
              value:
                'OBS: Vänligen notera att förslaget kan bli föremål för ändringar då någon proposition ännu inte har offentliggjorts av regeringen. Vi följer utvecklingen noggrant.',
            },
          ],
        },
        {
          id: 'tax-category2-2-1',
          name: 'Ränteavdrag N9 (Nuvarande regler)',
          image: 'gt/image/go_beyond/009.jpg',
          content: [
            {
              type: 'description',
              value: 'Se upp för fallgropar',
            },
            {
              type: 'description',
              value:
                'Ta hjälp i tid för att undvika misstag och för att optimera avdragsmöjligheter',
            },
            {
              type: 'subheading',
              value: 'Vad är ränta?',
            },
            {
              type: 'list-item',
              value:
                'Den skattemässiga definitionen av ränta är inte självklar, t.ex.',
            },
            {
              type: 'list-subitem',
              value:
                'Räntekomponent i finansiell leasing om mer än 1 mkr i leasingavgifter i intressegemenskapen',
            },
            {
              type: 'list-subitem',
              value: 'Kostnad för upptagande av kredit',
            },
            {
              type: 'subheading',
              value: 'Undvik vanliga fallgropar',
            },
            {
              type: 'list-item',
              value:
                'Marknadsmässig ränta är viktigt även på koncerninterna mellanhavanden.',
            },
            {
              type: 'list-item',
              value:
                'Det negativa räntenettot beräknas per bolag. Räntenetton i de bolag som har ett negativt räntenetto läggs därefter ihop, utan att kvitta mot positiva räntenetton i andra bolag.',
            },
            {
              type: 'list-item',
              value: 'Koncernkvittning måste rapporteras på N9:an.',
            },
            {
              type: 'list-item',
              value:
                'Intressegemenskap utgår från bestämmande inflytande i ÅRL, vilket bl.a. medför att svenska företag med gemensamt utländskt moderföretag ingår i en intressegemenskap.',
            },
            {
              type: 'list-item',
              value: 'Om möjligt - städa bort interna lån.',
            },
            {
              type: 'list-item',
              value:
                'OBS: Notera att reglerna förväntas ändras från 1 januari 2026 (se separat slide).',
            },
          ],
        },
        {
          id: 'tax-category2-2-2',
          name: 'Skattemässiga underskott',
          image: 'gt/image/go_beyond/010.jpg',
          content: [
            {
              type: 'description',
              value:
                'De förändrade underskottsreglerna trädde i kraft den 1 januari 2025 och tillämpas på ägarförändringar efter den 31 december 2024.',
            },
            {
              type: 'subheading',
              value: 'Vilka förändringar har införts?',
            },
            {
              type: 'list-item',
              value: 'Höjd kvot vid beräkning av beloppsspärren.',
            },
            {
              type: 'list-item',
              value: 'Undantag från beloppsspärren för vissa ägarförändringar.',
            },
            {
              type: 'list-item',
              value:
                'Förenkling av reglerna vid förvärv av grupp av sinsemellan oberoende fysiska personer.',
            },
            {
              type: 'list-item',
              value:
                'Förändring av beräkningen av utgiften för förvärv av underskottsföretag i vissa fall.',
            },
            {
              type: 'subheading',
              value: 'Vad gäller nu?',
            },
            {
              type: 'list-item',
              value:
                'Beloppsspärren ska beräknas till 300 % av utgiften för att förvärva ett underskottsföretag, jämfört med tidigare 200 %.',
            },
            {
              type: 'list-item',
              value:
                'Undantag från tillämpning av beloppsspärren vid vissa förvärv inom en oäkta koncern.',
            },
            {
              type: 'list-item',
              value:
                'Beloppsspärren inträder nu vid ägarförändringar där en grupp fysiska personer förvärvat minst 20 % vardera och över 50 % totalt av rösterna i ett underskottsföretag inom tre beskattningsår (flockregeln), jämfört med tidigare krav på minst 5 % vardera under fem beskattningsår.',
            },
            {
              type: 'list-item',
              value:
                'Undantaget om att vissa kapitaltillskott till underskottsföretag inte ska minska förvärvsutgiften gäller nu även tillskott till andra företag förutsatt att de före och efter ägarförändringen ingick i samma koncern.',
            },
            {
              type: 'tag',
              value:
                'OBS! För ägarförändringar som inträffat innan 31 december 2024 ska då gällande regler tillämpas.',
            },
          ],
        },
        {
          id: 'tax-category2-2-3',
          name: 'Forskning & utveckling',
          image: 'gt/image/go_beyond/011.jpg',
          content: [
            {
              type: 'description',
              value:
                'Nytt förslag med förenklade regler för FoU avdrag har presenterats. Fortsatt restriktiv tillämpning inom nuvarande regelverk. Detta gäller särskilt avseende IT och mjukvarubolag.',
            },
            {
              type: 'subheading',
              value: 'Riskhantering',
            },
            {
              type: 'list-item',
              value:
                'Vi rekommenderar att ett yrkande görs öppet mot Skatteverket oavsett om man yrkar löpande i arbetsgivardeklarationen eller retroaktivt genom att begära omprövning av gamla perioder.',
            },
            {
              type: 'list-item',
              value:
                'Att inte yrka öppet kan föranleda nekat avdrag samt skattetillägg.',
            },
            {
              type: 'subheading',
              value: 'Nyheter',
            },
            {
              type: 'list-item',
              value:
                'Den 15 januari 2025 presenterades ett delbetänkande avseende skatteincitamentet för forskning och utveckling (SOU 2025:3).',
            },
            {
              type: 'list-item',
              value:
                'Utredningens uppdrag har varit att se över nedsättningen av arbetsgivaravgifterna och den allmänna löneavgiften för personer som arbetar med forskning eller utveckling (FoU-avdraget) ',
            },
            {
              type: 'list-item',
              value: 'I delbetänkandet föreslås bland annat följande:',
            },
            {
              type: 'list-subitem',
              value:
                'Nya definitioner: Forskning ska definieras som arbete med att i kommersiellt syfte ta fram ny kunskap. Utveckling ska definieras som arbete med att i kommersiellt syfte ta fram eller förbättra varor, tjänster eller produktions-processer genom nya lösningar på vetenskapliga eller tekniska problem.',
            },
            {
              type: 'list-subitem',
              value: 'Kravet på att arbetet ska vara "systematiskt" tas bort.',
            },
            {
              type: 'list-subitem',
              value:
                'Slopat krav på minst 15 timmars arbete för att kvalificera sig för FoU-avdraget.',
            },
            {
              type: 'list-subitem',
              value:
                'Ökad samarbete mellan myndigheter för objektivare bedömningar',
            },
          ],
        },
        {
          id: 'tax-category2-2-4',
          name: 'Likviditets- och kassaflödesfrågor',
          image: 'gt/image/go_beyond/012.jpg',
          content: [
            {
              type: 'description',
              value:
                'Att löpande se över sin likviditet och sitt kassaflöde är alltid viktigt, men än mer i en lågkonjunktur. Det ger förutsättning att försöka anpassa verksamheten och ligga steget före.',
            },
            {
              type: 'subheading',
              value: 'Löpande arbete - men oftare i dåliga tider',
            },
            {
              type: 'list-item',
              value: 'Gör likviditetsplanering!',
            },
            {
              type: 'list-item',
              value: 'Gör kassaflödesanalys!',
            },
            {
              type: 'list-item',
              value: 'Se över avtal!',
            },
            {
              type: 'subheading',
              value: 'Tips på särskilda regelverk:',
            },
            {
              type: 'list-item',
              value: 'Återbetalning för energiskatt i tillverkande industrier?',
            },
            {
              type: 'list-item',
              value: 'FoU-avdrag?',
            },
            {
              type: 'list-item',
              value: 'Avräkning av utländsk skatt?',
            },
            {
              type: 'subheading',
              value: 'Generella tips',
            },
            {
              type: 'list-item',
              value: 'Se över preliminärskatt.',
            },
            {
              type: 'list-item',
              value: 'Är direktavdrag i fastighetsprojekt möjligt?',
            },
            {
              type: 'list-item',
              value:
                'Finns det ett utrymme för större avskrivningar enligt de principer ni tillämpar?',
            },
          ],
        },
      ],
    },
    {
      id: 'tax-category3',
      name: 'Internationell beskattning',
      image: 'gt/image/go_beyond/013.jpg',
      categories: [
        {
          id: 'tax-category3-1',
          name: 'Individbeskattning',
          image: 'gt/image/go_beyond/014.jpg',
          items: [
            {
              id: 'tax-category3-1-1',
              name: 'Stadigvarande vistelse',
              image: 'gt/image/go_beyond/015.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Nytt lagförslag avseende begreppet "stadigvarande vistelse" i Sverige',
                },
                {
                  type: 'subheading',
                  value: 'Reglernas innebörd',
                },
                {
                  type: 'list-item',
                  value:
                    'SKV har i en promemoria föreslagit att en definition av uttrycket stadigvarande vistelse införs i inkomstskattelagen.',
                },
                {
                  type: 'list-item',
                  value:
                    'Förslaget innebär att stadigvarande vistelse definieras som vistelse som under ett kalenderår omfattar fler än 160 vistelsedagar, eller fler än 120 vistelsedagar om antalet vistelsedagar även under det närmast föregående året översteg 120.',
                },
                {
                  type: 'subheading',
                  value:
                    'Vad är stadigvande vistelse och vad innebär lagförslaget?',
                },
                {
                  type: 'list-item',
                  value:
                    'Man kan vara obegränsat skattskyldig i Sverige baserat på tre grunder, dvs. om man är:',
                },
                {
                  type: 'list-subitem',
                  value: 'Bosatt i Sverige,',
                },
                {
                  type: 'list-subitem',
                  value: 'Vistas stadigvarande i Sverige, eller',
                },
                {
                  type: 'list-subitem',
                  value: 'Har kvar väsentlig anknytning till Sverige',
                },
                {
                  type: 'list-item',
                  value:
                    'Rättspraxis avseende stadigvarande vistelse är spretig och därmed svår att använda, både för rådgivare och SKV.',
                },
                {
                  type: 'list-item',
                  value:
                    'De nya reglerna med en tydlig kvantitativ definition skulle underlätta bedömningen av om en individ anses vistas stadigvarande i Sverige samt ge individen ett tydligt antal dagar att förhålla sig till.',
                },
              ],
            },
            {
              id: 'tax-category3-1-2',
              name: 'Expertskatt',
              image: 'gt/image/go_beyond/016.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Expertskatt: sänkt ersättningsnivå från 2 till 1,5 prisbasbelopp per månad för att kvalificera för expertskatt. Gäller från den 1 januari 2025.',
                },
                {
                  type: 'subheading',
                  value: 'Reglernas innebörd',
                },
                {
                  type: 'list-item',
                  value:
                    'Kvalificerar en individ för expertskatt undantas 25% av lön och förmåner från beskattning under sju års tid.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skattefrihet omfattar även utgifter för flytt, skolavgifter, två hemresor per familjemedlem och år.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skattefri ersättning undantas från svenska sociala avgifter.',
                },
                {
                  type: 'subheading',
                  value: 'Vilka kan omfattas av expertskattereglerna',
                },
                {
                  type: 'list-item',
                  value: 'Experter och forskare samt nyckelpersoner, t ex VD',
                },
                {
                  type: 'list-item',
                  value:
                    'Lättnad grundad på ersättningsnivå: Månatliga, till sin storlek bestämda, ersättningar mer än 1,5 prisbasbelopp per månad (>88 200 kronor för 2025). Exempel på förmåner som kan beaktas för ersättningsnivån: bostadsförmån, bilförmån (ej ex drivmedel, kostnadsersättningar och bonusar (p g a varierande till sin storlek).',
                },
                {
                  type: 'list-item',
                  value:
                    'Ej svensk medborgare/ej bosatt i Sverige senaste fem åren',
                },
                {
                  type: 'list-item',
                  value:
                    'Ansökan till Forskarskattenämnden inom tre månader från det att arbetet i Sverige påbörjades. Ej möjligt att ansöka senare.',
                },
                {
                  type: 'list-item',
                  value: 'Svensk utbetalare',
                },
              ],
            },
          ],
        },
        {
          id: 'tax-category3-2',
          name: 'Företagsbeskattning',
          image: 'gt/image/go_beyond/017.jpg',
          items: [
            {
              id: 'tax-category3-2-1',
              name: 'ATAD 3',
              image: 'gt/image/go_beyond/018.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Direktivförslag för att motverka missbruk av holdingbolag inom EU (ATAD 3). Ikraftträdande initialt beräknat i januari 2025 med två års retroaktiv effekt, initiativet för nuvarande pausat',
                },
                {
                  type: 'subheading',
                  value: 'Förslagets innehåll i korthet',
                },
                {
                  type: 'list-item',
                  value:
                    'Motverka slussning av inkomster från företag utan tillräcklig substans till annan stat inom eller utanför EU.',
                },
                {
                  type: 'list-item',
                  value: 'Införande av ”substanstest”.',
                },
                {
                  type: 'list-item',
                  value:
                    'Årlig rapporteringsplikt för högriskföretag i deklarationen.',
                },
                {
                  type: 'list-item',
                  value:
                    'Högriskföretag utan substans föreslås förlora fördelar av skatteavtal och EU-direktiv.',
                },
                {
                  type: 'subheading',
                  value: 'Vilka företag omfattas?',
                },
                {
                  type: 'paragraph',
                  value: 'Kriterier för identifiering av högriskföretag:',
                },
                {
                  type: 'list-item',
                  value:
                    'Minst 65 % passiva inkomster (räntor, utdelning, royalties m.m.),',
                },
                {
                  type: 'list-item',
                  value: 'gränsöverskridande verksamhet, och',
                },
                {
                  type: 'list-item',
                  value:
                    'outsourcat ledning och administration de två senaste beskattningsåren.',
                },
                {
                  type: 'list-item',
                  value:
                    'Alla internationella koncerner omfattas, oavsett storlek i omsättning.',
                },
                {
                  type: 'subheading',
                  value: 'När?',
                },
                {
                  type: 'list-item',
                  value:
                    'Sverige förväntades införliva direktivet i svensk rätt från och med 1 januari 2025, men i och med att inget slutligt direktiv antagits så är tidsramarna fortfarande inte bestämda.',
                },
              ],
            },
            {
              id: 'tax-category3-2-2',
              name: 'F-skatt för utländska företag',
              image: 'gt/image/go_beyond/019.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Regler för utländska företag som fakturerar för arbete utfört i Sverige och för utländska företag med anställda i Sverige',
                },
                {
                  type: 'subheading',
                  value: 'Reglernas innebörd',
                },
                {
                  type: 'list-item',
                  value:
                    'Utländska bolag som utför arbete fysiskt i Sverige ska registreras för F-skatt, oberoende frågan om fast driftställe (skattskyldighet i Sverige).',
                },
                {
                  type: 'list-item',
                  value:
                    // tslint:disable-next-line:max-line-length
                    'Om F-skatt saknas ska betalaren av faktura för arbete utfört i Sverige innehålla 30 % på fakturan.',
                },
                {
                  type: 'list-item',
                  value:
                    'Även utländsk personal som arbetar för det utländska bolaget kan vara skattepliktig i Sverige.',
                },
                {
                  type: 'subheading',
                  value: 'Vad innebär det?',
                },
                {
                  type: 'list-item',
                  value:
                    'Vid betalning till utländska företag där arbete utförts på plats i Sverige måste det säkerställas att det utländska företaget innehar F-skatt.',
                },
                {
                  type: 'list-item',
                  value:
                    'Har det utländska bolaget inte F-skatt måste skatt innehållas på betalningar som avser arbete utfört i Sverige. Skatten redovisas och betalas till Skatteverket genom AGI (arbetsgivardeklarationer) månatligen.',
                },
                {
                  type: 'list-item',
                  value:
                    'Nyligen har det dykt upp rättsfall där bolag missat att kontrollerat F-skatt/innehållit 30 % skatt. Skattetillägg om 5 % har utgått.',
                },
                {
                  type: 'list-item',
                  value:
                    'En revisor bör vara extra vaksam så att skatteavdrag har gjorts i dem fallen där det behövs, då en oren revisionsberättelse kan behöva skickas in om bolaget inte fullgjort sina skatteförpliktelser.',
                },
              ],
            },
            {
              id: 'tax-category3-2-3',
              name: 'Pillar II',
              image: 'gt/image/go_beyond/020.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Global minimibeskattning (Pelare 2). Från 31 december 2023 har regler trätt ikraft som innebär att vissa stora företag blir föremål för regler om global minimibeskattning, så kallad tilläggsskatt, samt ett helt nytt sätt att beräkna effektiv skattesats.',
                },
                {
                  type: 'subheading',
                  value: 'För vilka gäller detta?',
                },
                {
                  type: 'list-item',
                  value:
                    'Multinationella företag med en global omsättning överstigande 750 miljoner euro.',
                },
                {
                  type: 'subheading',
                  value: 'Från när?',
                },
                {
                  type: 'list-item',
                  value:
                    'I Sverige har reglerna införts genom bland annat en lag om tilläggsskatt.',
                },
                {
                  type: 'list-item',
                  value: 'Reglerna är tillämpliga fr.o.m. 1 januari 2024.',
                },
                {
                  type: 'subheading',
                  value: 'Vad innebär förslaget?',
                },
                {
                  type: 'list-item',
                  value:
                    'Införandet av en minimiskatt om 15 % för multinationella företag med en årlig global intäkt på koncernnivå överstigande 750 miljoner euro.',
                },
                {
                  type: 'list-item',
                  value:
                    'Reglerna innebär att en tilläggsskatt tas ut på vinster i alla jurisdiktioner där den effektiva skattesatsen, som fastställs på jurisdiktionsbasis, är längre än minimiskatten på 15 %.',
                },
                {
                  type: 'tag',
                  value:
                    'OBS: Koncernenheter (förenklat företag) som omfattas av lag om tilläggsskatt ska registrera sig hos Skatteverket senast mars 2026.',
                },
              ],
            },
            {
              id: 'tax-category3-2-4',
              name: 'DAC 9',
              image: 'gt/image/go_beyond/021.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Förslaget, som har en nära koppling till Pillar II, ska underlätta för skattemyndigheter inom EU att utbyta information med varandra i syfte att minska den administrativa bördan för multinationella företag.',
                },
                {
                  type: 'subheading',
                  value: 'Vad är syftet med förslaget?',
                },
                {
                  type: 'list-item',
                  value:
                    'Syftet med DAC 9 är att förenkla rapporteringskraven för multinationella koncerner (MNEs) och stora nationella koncerner (LSDGs) inom EU.',
                },
                {
                  type: 'subheading',
                  value: 'Vad innebär förslaget?',
                },
                {
                  type: 'list-item',
                  value:
                    'Upprättandet av ett gemensamt system för skattemyndigheter inom EU att utbyta information med varandra',
                },
                {
                  type: 'list-item',
                  value:
                    'Införandet av en centraliserad tilläggsskatterapport som avser hela koncernen vilken bara behöver lämnas av moderföretaget (eller en annan koncernenhet som utsetts för inlämning av tilläggsskatterapport).',
                },
                {
                  type: 'tag',
                  value:
                    'OBS:  Vänligen notera att förslaget ännu inte har antagits av EU:s lagstiftande institutioner.',
                },
              ],
            },
            {
              id: 'tax-category3-2-5',
              name: 'BEFIT - Ramverk för inkomstskatt',
              image: 'gt/image/go_beyond/022.jpg',
              content: [
                {
                  type: 'description',
                  value: 'Direktiv avseende gemensam skattebas inom EU',
                },
                {
                  type: 'subheading',
                  value: 'För vilka gäller detta?',
                },
                {
                  type: 'list-item',
                  value:
                    'Multinationella företag med en global omsättning överstigande 750 miljoner euro och >75 % ägande.',
                },
                {
                  type: 'list-item',
                  value: 'Ej EU ägda koncerner omfattas om >50 % ägande.',
                },
                {
                  type: 'subheading',
                  value: 'Från när?',
                },
                {
                  type: 'list-item',
                  value:
                    'Förslag 12 september 2023 om det godkänns ska det implementeras 1 januari 2028.',
                },
                {
                  type: 'subheading',
                  value: 'Vad innebär förslaget?',
                },
                {
                  type: 'list-item',
                  value:
                    'BEFIT-förslaget innebär att bolag i samma koncern ska beräkna sitt skatteunderlag enligt ett gemensamt regelverk.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteunderlaget aggregeras i en gemensam skattebas och fördelas mellan bolagen i koncernen på basis av en fördelningsnyckel som bygger på det genomsnittliga skattemässiga resultatet av de tre senaste åren.',
                },
              ],
            },
            {
              id: 'tax-category3-2-6',
              name: 'Transfer Pricing',
              image: 'gt/image/go_beyond/023.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Nytt: Obligatorisk inlämning av Transfer Pricing-dokumentation i Danmark och krav på benchmarking studier vid tillämpning av TNMM',
                },
                {
                  type: 'subheading',
                  value: 'För vilka bolag gäller INTE dessa regler?',
                },
                {
                  type: 'list-item',
                  value:
                    'Koncerner med färre än 250 anställda och antingen en balansomslutning på mindre än 125 miljoner DKK eller en omsättning på mindre än 250 miljoner DKK  (innevarande år).',
                },
                {
                  type: 'subheading',
                  value: 'Vad innebär detta?',
                },
                {
                  type: 'list-item',
                  value:
                    'Fr.om. räkenskapsår 2021 ska TP-dokumentationen lämnas inom 60 d från deklarationstidpunkten annars risk om böter på upp till 250 000 DKK.​',
                },
                {
                  type: 'list-item',
                  value:
                    'Fr.om. räkenskapsår 2022 krav på benchmarkingstudier vid användandet av TNMM som prissättningsmetod.',
                },
                {
                  type: 'subheading',
                  value: 'Exempel på länder att bevaka (ej uttömmande):',
                },
                {
                  type: 'list-item',
                  value:
                    'Lettland - Krav på att skicka in dokumentation till skattemyndigheten, dokumentation på lettiska, höga böter',
                },
                {
                  type: 'list-item',
                  value:
                    'Litauen - Krav på att skicka in dokumentation till skattemyndigheten, dokumentation på litauiska, höga böter',
                },
                {
                  type: 'list-item',
                  value:
                    'Tyskland - Aktiv skattemyndighet - ofta revision, från och med 1 januari 2025 kompletteras dokumentation med en transaktionsmatris',
                },
                {
                  type: 'list-item',
                  value:
                    'Polen - Strikt lagstiftning och tillämpning, dokumentation på polska, årlig inlämning av TPR-C (”TP-deklaration”)',
                },
                {
                  type: 'list-item',
                  value:
                    'Indien - Krav på att skicka in till skattemyndigheten, accepterar inte finansiell uppdatering av benchmarks',
                },
                {
                  type: 'list-item',
                  value:
                    'Kina - Problematiskt vid "year-end adjustments" (skatt och tull)',
                },
                {
                  type: 'list-item',
                  value:
                    'Australien - Tuffa krav på innehåll och benchmarkingstudier',
                },
                {
                  type: 'list-item',
                  value:
                    'Brasilien - Har precis börjat tillämpa OECD:s riktlinjer. Man bör konsultera lokal expertis',
                },
                {
                  type: 'list-item',
                  value:
                    'UK - Ändringar av TP-regler som kommer påverka stora företag (global intäkt över 750 mEUR ) fr.om. 1 april 2023. MF och LF måste upprättas och filas inom 30 dagar efter förfrågan. Ska även ha en ”Summary audit trail” tillgänglig (frågelista och bevis på vilka åtgärder som vidtagits för att upprätta LF).',
                },
                {
                  type: 'list-item',
                  value:
                    'Malta - Har antagit TP-regler som kommer gälla från och med 1 januari 2024',
                },
                {
                  type: 'list-item',
                  value:
                    'Italien - För att få straffrättsligt skydd ställs krav på dokumentation, dokumentation på italienska, signerad och stämplad inom viss tid, höga sanktioner',
                },
              ],
            },
          ],
        },
      ],
    },
    {
      id: 'tax-category4',
      name: 'Moms',
      image: 'gt/image/go_beyond/024.jpg',
      categories: [
        {
          id: 'tax-category4-1',
          name: 'Nyheter',
          image: 'gt/image/go_beyond/025.jpg',
          items: [
            {
              id: 'tax-category4-1-1',
              name: 'Nytt från lagstiftaren',
              image: 'gt/image/go_beyond/026.jpg',
              content: [
                {
                  type: 'description',
                  value: 'Ändringar på momsområdet',
                },
                {
                  type: 'subheading',
                  value: 'Varför görs dessa ändringar?',
                },
                {
                  type: 'list-item',
                  value: 'Anpassningar till mervärdesskattedirektivet',
                },
                {
                  type: 'list-item',
                  value: 'EU har klargjort momsen på virtuella evenemang',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Evenemang med fysisk närvaro beskattas i det land där evenemanget tar plats',
                },
                {
                  type: 'subheading',
                  value: 'Vad ändras?',
                },
                {
                  type: 'list-item',
                  value: 'Konstverk',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Skattesatsen 12 procent gäller vid all försäljning av konstverk.',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Gäller inte om reglerna om vinstmarginalbeskattning (VMB) tillämpas.',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Begränsningen att konstverket måste ägas av upphovsmannen eller dennes dödsbo tas bort.',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Den reducerade skattesatsen vid leverans av konstverk gäller därmed oavsett vem som säljer konstverken.',
                },
                {
                  type: 'list-item',
                  value: 'Virtuella evenemang ',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Kulturella, konstnärliga, idrottsliga, vetenskapliga, pedagogiska, evenemang av underhållningskaraktär eller liknande.',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Om köparen är en beskattningsbar person anses tjänsterna tillhandahållna där köparen har sitt säte.',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Om köparen är en icke beskattningsbar person, anses tjänsten tillhandahållen där köparen är etablerad, är bosatt eller stadigvarande vistas.',
                },
              ],
            },
            {
              id: 'tax-category4-1-2',
              name: 'Höjd omsättningsgräns',
              image: 'gt/image/go_beyond/027.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Omsättningsgränsen för när företag undantas från momsplikt höjs till 120 000 kronor',
                },
                {
                  type: 'subheading',
                  value: 'Proposition 2023/24:149',
                },
                {
                  type: 'list-item',
                  value:
                    'Omsättningsgränsen för skattebefrielse från moms kommer att höjas från 80 000 kronor till 120 000 kronor per beskattningsår',
                },
                {
                  type: 'list-item',
                  value:
                    'Även beskattningsbara personer etablerade i andra EU-länder ska omfattas av denna regel',
                },
                {
                  type: 'subheading',
                  value: 'Vad har hänt?',
                },
                {
                  type: 'list-item',
                  value:
                    'Från och med 1 juli 2022 har beskattningsbara personer som är registrerade för moms möjlighet att ansöka om att befrias från att redovisa moms om de beräknar ha en årsomsättning som understiger 80 000 kronor.',
                },
                {
                  type: 'list-item',
                  value:
                    'Från och med 1 januari 2025 höjs omsättningsgränsen till 120 000 kronor för företag som kan undantas från skatteplikt.',
                },
                {
                  type: 'list-item',
                  value:
                    'Företag med omsättning under den nya gränsen 120 000 kronor per år kan välja att avregistrera sig från momsredovisning från och med 1 januari 2025.',
                },
                {
                  type: 'list-item',
                  value:
                    'Beskattningsbara personer som omfattas av undantaget från moms på grund av omsättningsgränsen kan utfärda förenklad faktura även på belopp över 4 000 kronor för många transaktioner.',
                },
                {
                  type: 'list-item',
                  value:
                    'På den förenklade fakturan ska det anges att leveransen av varor eller tillhandahållandet av tjänster är undantagna från moms.',
                },
              ],
            },
          ],
        },
        {
          id: 'tax-category4-2',
          name: 'Skatterättsliga begrepp',
          image: 'gt/image/go_beyond/031.jpg',
          items: [
            {
              id: 'tax-category4-2-1',
              name: 'Ett eller flera tillhandahållanden?',
              image: 'gt/image/go_beyond/032.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Skatteverket har uppdaterat sina riktlinjer på hur ett eller flera tillhandahållanden ska bedömas',
                },
                {
                  type: 'subheading',
                  value: 'Vad har hänt?',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteverket har tagit fram en ny metod på hur man bedömer ett eller flera tillhandahållanden',
                },
                {
                  type: 'list-item',
                  value:
                    'Rättsligt har inget ändrats men metoden kan leda till andra bedömning från Skatteverket än tidigare',
                },
                {
                  type: 'subheading',
                  value: 'Ett eller flera tillhandahållanden',
                },
                {
                  type: 'list-item',
                  value:
                    'Ett eller flera tillhandahållanden inom momsen handlar om hur en transaktion, som består av olika varor eller tjänster, ska beskattas.',
                },
                {
                  type: 'list-item',
                  value:
                    'Beroende på om en eller flera varor eller tjänster tillhandahålls kan beskattningskonsekvenserna bli annorlunda.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteverket använder en ”egenutvecklad” metod för att avgöra om ett eller flera tillhandahållanden föreligger.',
                },
                {
                  type: 'list-item',
                  value:
                    'Om det är ett enda tillhandahållande, klassificeras det som en enhet och samma skattesats gäller hela tillhandahållandet. Om inte, är det flera separata tillhandahållanden som beskattas separat.',
                },
                {
                  type: 'list-item',
                  value:
                    'Beroende på bedömningen kan både skyldigheten att betala moms och vilken momssats som ska gälla påverkas.',
                },
              ],
            },
            {
              id: 'tax-category4-2-2',
              name: 'Kundförlust eller tvistig fordran?',
              image: 'gt/image/go_beyond/033.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Begrepp: Kundförlust - moms | Osäkra kundfordringar - skatt & redovisning | Tvistig fordran',
                },
                {
                  type: 'subheading',
                  value: 'Tvistig fordran eller nedsättning av pris?',
                },
                {
                  type: 'list-item',
                  value: 'Kunden inte vill betala hela/delar av fakturan?',
                },
                {
                  type: 'list-item',
                  value:
                    'Vad behöver jag tänka på innan jag sätter ner den tidigare redovisade utgående momsen?',
                },
                {
                  type: 'list-item',
                  value: 'En tvistig fordran är inte en kundförlust!',
                },
                {
                  type: 'list-item',
                  value:
                    'Säljaren lämnar en rabatt eller sänker priset på varan eller tjänsten',
                },
                {
                  type: 'list-item',
                  value: 'Ändringsfaktura!',
                },
                {
                  type: 'subheading',
                  value:
                    'Krav på konstaterad kundförlust för att kunna minska utgående moms',
                },
                {
                  type: 'list-item',
                  value:
                    'Vidtagit alla rimliga åtgärder för att driva in fordran (påminnelser, inkasso etc).',
                },
                {
                  type: 'list-item',
                  value:
                    'Huvudregel = att göra sannolikt att kunden saknar möjlighet att betala sin skuld.',
                },
                {
                  type: 'list-item',
                  value: 'Handling från KFM att köparen är i konkurs.',
                },
                {
                  type: 'list-item',
                  value:
                    'Säljaren har överlämnat sin fordran till Kronofogden som upprättar en utredningsrapport av vilken det framgår att köparen saknar tillgångar till full betalning av skulden.',
                },
              ],
            },
            {
              id: 'tax-category4-2-3',
              name: 'Momsregistrering',
              image: 'gt/image/go_beyond/034.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Om en momsregistrering har skett i god tro och innehållit de uppgifter som Skatteverket behövt för att kunna fatta beslut om registreringen kan den skattskyldige förlita sig på momsregistreringen',
                },
                {
                  type: 'subheading',
                  value: 'Mer än bara att fylla i en blankett',
                },
                {
                  type: 'list-item',
                  value: 'Viktigt att korrekt bedömning av verksamheten görs',
                },
                {
                  type: 'list-item',
                  value:
                    'Felaktig information kan medföra stor risk i momsredovisningen för kund eller dennes kunder',
                },
                {
                  type: 'subheading',
                  value: 'Berättigade förväntningar',
                },
                {
                  type: 'list-item',
                  value:
                    'Högsta förvaltningsdomstolen har uttalat att ett registreringsbeslut för moms innebär en bekräftelse på att Skatteverket vid tidpunkten för beslutet har bedömt att bolaget är skattskyldigt och bedriver ekonomisk verksamhet.',
                },
                {
                  type: 'list-item',
                  value:
                    'När skattskyldigheten väl har fastställts skulle det strida mot principerna om skydd för berättigade förväntningar och rättssäkerheten att med retroaktiv verkan ompröva detta beslut, så länge det inte rör sig om fall av bedrägeri eller missbruk.',
                },
              ],
            },

            {
              id: 'tax-category4-3-3',
              name: 'Internationell handel',
              image: 'gt/image/go_beyond/039.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Begrepp:Skilj på varu- och tjänstehandel | Import | Export',
                },
                {
                  type: 'subheading',
                  value: 'Stränga krav vid EU-handel (varor)',
                },
                {
                  type: 'list-item',
                  value:
                    'Krav på att köparen ska vara momsregistrerad i det andra EU-landet',
                },
                {
                  type: 'list-item',
                  value:
                    'Köparen ska ha meddelat momsregistreringsnumret till säljaren',
                },
                {
                  type: 'list-item',
                  value: 'Bevis som styrker transport till annat EU-land',
                },
                {
                  type: 'list-item',
                  value:
                    'Säljare måste kunna visa upp antingen två transporthandlingar eller en transporthandling tillsammans med en annan handling.',
                },
                {
                  type: 'list-item',
                  value: 'Kedjetransaktioner?',
                },
                {
                  type: 'list-item',
                  value: 'Export i flera led?',
                },
                {
                  type: 'list-item',
                  value: 'Betydelsen av Incoterms',
                },
                {
                  type: 'subheading',
                  value: 'Viktigt att tänka på!',
                },
                {
                  type: 'list-item',
                  value:
                    'Viktigt med bra samarbete mellan säljare och ekonomiavdelningen.',
                },
                {
                  type: 'list-item',
                  value: 'Dokumentera och spara bevis.',
                },
                {
                  type: 'list-item',
                  value: 'Behov av särskilda momsklausuler i avtal med kund?',
                },
                {
                  type: 'list-item',
                  value:
                    'Platsen för beskattning av tjänster? Behov av momsregistrering i utlandet?',
                },
                {
                  type: 'list-item',
                  value:
                    'Omsättning kopplad till moms behöver kunna stämmas av.',
                },
                {
                  type: 'list-item',
                  value: 'Tänk igenom och anpassa kontoplanen.',
                },
                {
                  type: 'list-item',
                  value: 'Identifiera risker och sätt upp kontrollrutiner.',
                },
              ],
            },
            {
              id: 'tax-category4-3-4',
              name: 'E-handel och moms',
              image: 'gt/image/go_beyond/040.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Var uppmärksam vid rapportering avseende e-handel till privatpersoner inom EU!',
                },
                {
                  type: 'subheading',
                  value: 'Syftet med reglerna?',
                },
                {
                  type: 'list-item',
                  value: 'Värna skattepengar inom EU',
                },
                {
                  type: 'list-item',
                  value: 'Rättvis konkurrens',
                },
                {
                  type: 'list-item',
                  value: 'Beskattning där konsumtion sker',
                },
                {
                  type: 'list-item',
                  value:
                    'Underlätta administration för företagen (undvika momsregistrering i många EU-länder)',
                },
                {
                  type: 'subheading',
                  value: 'För e-handel (B2C) gäller bland annat:',
                },
                {
                  type: 'list-item',
                  value:
                    'Moms ska redovisas i det land inom EU där privatperson finns om total försäljning årsvis inom EU uppgår till 99 680 kronor.',
                },
                {
                  type: 'list-item',
                  value:
                    'Redovisning kan ske i en särskild OSS-deklaration (One-Stop Shop) via Sverige. Särskilda regler finns vid import.',
                },
                {
                  type: 'list-item',
                  value:
                    'Marknadsplatser på nätet kan bli skyldiga att redovisa andra bolags moms.',
                },
                {
                  type: 'list-item',
                  value:
                    'Drop-shipping (varorna går direkt från leverantör till slutkund utan att lagerhållas hos återförsäljaren) kan ställa till problem.',
                },
                {
                  type: 'list-item',
                  value:
                    'Momsredovisningen kan bli komplex för bolagen. T.ex. försäljning från lager i Danmark till privatperson i Sverige ska redovisas i OSS-deklarationen, inte i den vanliga svenska momsdeklarationen.',
                },
              ],
            },
          ],
        },
        {
          id: 'tax-category4-3',
          name: 'Domar & avgöranden',
          image: 'gt/image/go_beyond/036.jpg',
          items: [
            {
              id: 'tax-category4-1-4',
              name: 'Momsavdrag vid blandad verksamhet',
              image: 'gt/image/go_beyond/029.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Högsta förvaltningsdomstolen 2023-10-16 (HFD mål nr. 7254-7255-22). Ingående moms på gemensamma kostnader i blandad verksamhet kan alltid dras av enligt omsättningsbaserad beräkningsmetod.',
                },
                {
                  type: 'subheading',
                  value: 'Avdragsrätt vid blandad verksamhet',
                },
                {
                  type: 'list-item',
                  value:
                    'Med blandad verksamhet avses att både momspliktig och momsfri verksamhet bedrivs',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteverket anser att direkt effekt av direktivets bestämmelser inte kan åberopas vid uppdelningen när det gäller en avdragsbegränsning (t.ex. stadigvarande bostad)',
                },
                {
                  type: 'subheading',
                  value: 'Vad har hänt?',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteverket har tidigare ansett att exempelvis fastighetsbolag som har både momspliktiga och momsfria hyresintäkter normalt ska använda yta som fördelningsgrund för gemensamma inköp.',
                },
                {
                  type: 'list-item',
                  value:
                    'HFD slår fast att företag som bedriver blandad verksamhet i momshänseende har rätt att beräkna momsavdrag på gemensamma kostnader med omsättning som fördelningsgrund.',
                },
                {
                  type: 'list-item',
                  value:
                    'Företag med blandad verksamhet bör se över tillämpad metod för beräkning av avdragsgill ingående moms på gemensamma kostnader. Möjlighet att begära omprövning för tidigare år kan föreligga om omsättningen t.ex. är mer fördelaktig än yta.',
                },
              ],
            },
            {
              id: 'tax-category4-2-4',
              name: 'Momspliktig bruttolöneförmån',
              image: 'gt/image/go_beyond/035.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Högsta förvaltningsdomstolen 2024-05-27 (HFD 2024 ref. 33). Tillhandahållande av förmåner till anställda mot bruttolöneavdrag är i regel momspliktigt.',
                },
                {
                  type: 'subheading',
                  value: 'Att tänka på vid brutto-, eller nettolöneförmåner',
                },
                {
                  type: 'list-item',
                  value:
                    'Efter HFD:s dom är det oklart om andra brutto-, eller nettolöneförmåner ska räknas som momspliktiga tjänster. Praxis kan komma att utvecklas på detta område.',
                },
                {
                  type: 'list-item',
                  value:
                    'Brutto-, eller nettolönförmåner kan även behövas rättas bakåt i tiden. Oklart rättsläge!',
                },
                {
                  type: 'list-item',
                  value:
                    'Hanteras redovisningen fel kan Skatteverket neka momsavdrag på inköpen.',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Ett bolag kan även bli uttagsbeskattad samt få sina förmåner omvärderade.',
                },
                {
                  type: 'subheading',
                  value: 'Vad har hänt?',
                },
                {
                  type: 'list-item',
                  value:
                    'Angående bruttolöneförmåner har HFD kommit fram till att cyklar vars värde dras från bruttolönen ska anses vara en momspliktig tjänst.',
                },
                {
                  type: 'list-item',
                  value:
                    'Ett bolag ville erbjuda sina anställda förmåns-cyklar. Detta tillhandahölls genom ett avdrag på den anställdes bruttolön.',
                },
                {
                  type: 'list-item',
                  value:
                    'HFD ansåg att på grund av att löneavdraget kunde mätas i pengar samt att motprestationen var villkorad med avdraget, utgjorde detta en momspliktig tjänst. Detta gäller även kommuner enligt HFD (HFD 4096-24) trots de inte bedriver ekonomisk verksamhet!',
                },
                {
                  type: 'list-item',
                  value:
                    'Detta innebär att en arbetsgivaren nu kan behöva redovisa moms på brutto-, eller nettolöneförmåner till sina anställda.',
                },
              ],
            },
            {
              id: 'tax-category4-1-5',
              name: 'Fördelningsnyckeln och stadigvarande boende',
              image: 'gt/image/go_beyond/030.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Skatterättsnämndens avgörande den 2024-11-15 (SRN dnr 35 & 56 -24/I. Företag och föreningar med blandad verksamhet (både momspliktig och momsfri) kan dra av en del av momsen på gemensamma inköp, även om det omfattar bostäder.',
                },
                {
                  type: 'subheading',
                  value: 'Frivillig beskattning:',
                },
                {
                  type: 'list-item',
                  value:
                    'Den som bedriver blandad verksamhet, både momspliktig och momsfri, kan dra av en viss del av momsen på gemensamma inköp i den blandade verksamheten. Enligt svenska momslagen ska momsavdrag för gemensamma inköp ske genom uppdelning efter skälig grund. I momsdirektivet anges en omsättningsbaserad metod.',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Skatteverket anser att det inte går att göra avdrag vid gemensamma inköp i verksamhet som omfattar uttryckligt momsundantagna områden, som bostäder.',
                },
                {
                  type: 'subheading',
                  value: 'Vad har hänt?',
                },
                {
                  type: 'list-item',
                  value:
                    'En bostadsrättsförening hyr ut både bostäder och lokaler och har valt frivillig beskattning för lokaluthyrningen. Frågan gäller om föreningen kan åberopa direkt effekt av momsdirektivet vid uppdelning av den ingående momsen.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteverket hävdar att avdragsförbudet angående bostäder hindrar en från att tillämpa omsättningsbaserad fördelningsnyckel.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatterättsnämnden har ansett att momslagen inte ställer ett krav på en specifik beräkningsmetod och att man därmed kan använda omsättning som fördelningsnyckel vid gemensamma inköp för fastigheter med både momspliktiga lokaler och momsfria bostäder.',
                },
                {
                  type: 'list-item',
                  value: 'Målet är överklagat till HFD!',
                },
              ],
            },
            {
              id: 'tax-category4-1-3',
              name: 'Frivillig beskattning',
              image: 'gt/image/go_beyond/028.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Skatterättsnämndens avgörande den 2024-09-30 (SRN 17-24/I). Uthyrning med frivillig beskattning påverkas inte av en vidareuthyrning till en icke beskattningsbar person längre ned i hyreskedjan.',
                },
                {
                  type: 'subheading',
                  value: 'Frivillig beskattning:',
                },
                {
                  type: 'list-item',
                  value:
                    'Huvudregeln är att uthyrning av fastighet är undantagen från momsplikt, men det finns möjlighet till frivillig beskattning om:',
                },
                {
                  type: 'list-subitem',
                  value: 'Fastigheten hyrs ut för stadigvarande användning',
                },
                {
                  type: 'list-subitem',
                  value: 'Uthyrningen sker till en momspliktig verksamhet',
                },
                {
                  type: 'list-subitem',
                  value:
                    'Skatteverket anser att om en vidaruthyrning sker från den första hyresgästen måste den ske momspliktig för att frivillig beskattning ska kunna tillämpas mellan hyresvärd och första hyresgästen',
                },
                {
                  type: 'subheading',
                  value: 'Vad har hänt?',
                },
                {
                  type: 'list-item',
                  value:
                    'Bolaget i målet äger en byggnad som den hyr ut till en selfstorageoperatör, som i sin tur hyr ut till både momspliktiga personer och icke momspliktiga personer.',
                },
                {
                  type: 'list-item',
                  value:
                    'Bolaget frågade Skatterättsnämnden om de kunde tillämpa frivillig beskattning för hela byggnaden gentemot operatören.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteverket ansåg att, i och med att selfstorageoperatören hyrde ut lokalerna till bland annat icke momspliktiga personer, kunde Bolaget inte tillämpa frivillig beskattning på hela byggnaden.',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatterättsnämnden bedömde att Bolaget kan tillämpa frivillig beskattning för hela fastigheten mot operatören, med hänvisning till att operatören bedriver en enhetlig verksamhet utifrån lagtextens lydelse. Att den i sin tur hyr ut till bland annat icke momspliktiga personer påverkar inte denna bedömning.',
                },
                {
                  type: 'list-item',
                  value: 'Målet är överklagat till HFD!',
                },
              ],
            },
            {
              id: 'tax-category4-3-1',
              name: 'Avdrag vid dotterbolagsförsäljning',
              image: 'gt/image/go_beyond/037.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Högsta förvaltningsdomstolen 2023-09-26 (HFD 2023 ref. 41) Utökad möjlighet till avdragsrätt! Momsavdrag på konsultkostnader vid försäljning av dotterbolagsaktier, trots att det inte finns extern verksamhet.',
                },
                {
                  type: 'subheading',
                  value: 'Avdragsrätt för kostnader vid aktie-försäljning',
                },
                {
                  type: 'list-item',
                  value:
                    'Försäljning av aktier är undantaget från moms och avdragsrätt saknas därför på inköp direkt hänförliga till aktieförsäljningen ',
                },
                {
                  type: 'list-item',
                  value:
                    'Avdragsrätt kan föreligga om kostnaderna har samband med moderbolagets samlade momspliktiga ekonomiska verksamhet (allmän omkostnad)',
                },
                {
                  type: 'subheading',
                  value: 'Vad har hänt?',
                },
                {
                  type: 'list-item',
                  value:
                    'Skatteverket har tidigare ansett att avdragsrätt för konsultkostnader endast kan medges om syftet med försäljningen är att effektivisera och frigöra kapital till den egna  kvarvarande momspliktiga verksamheten mot externa kunder.',
                },
                {
                  type: 'list-item',
                  value:
                    'HFD öppnar upp för att kostnader kan vara avdragsgilla även om eget tillhandahållanden mot externa kunder saknas, och syftet till viss del är att åstadkomma ett kapitaltillskott till andra bolag inom koncernen.',
                },
                {
                  type: 'list-item',
                  value:
                    'Beräkning av momsavdragets storlek återförvisades till kammarrätten för prövning. Kammarrätten beviljade företaget i fråga full avdragsrätt. HFD har avslagit Skatteverkets överklagan och därmed står Kammarrättens dom fast.',
                },
              ],
            },
            {
              id: 'tax-category4-3-2',
              name: 'Holdingbolag och avdragsrätt',
              image: 'gt/image/go_beyond/038.jpg',
              content: [
                {
                  type: 'description',
                  value:
                    'Högsta förvaltningsdomstolen 2024-03-12 (HFD 2024 ref. 18) Utökad möjlighet till avdragsrätt! Avdragsrätten för moms kan variera i ett holdingbolag.',
                },
                {
                  type: 'subheading',
                  value: 'Momsreglerna i korthet',
                },
                {
                  type: 'list-item',
                  value:
                    'Ett passivt holdingbolag har som enda verksamhet att äga andelar i andra bolag utan att direkt eller indirekt delta i förvaltning',
                },
                {
                  type: 'list-item',
                  value:
                    'Ett aktivt holdingbolag deltar i förvaltningen och anses bedriva ekonomisk verksamhet i momshänseende',
                },
                {
                  type: 'list-item',
                  value:
                    'Avdragsrätten för moms kan variera i ett holdingbolag',
                },
                {
                  type: 'subheading',
                  value: 'Tänk på:',
                },
                {
                  type: 'paragraph',
                  value:
                    'Det finns flera saker att vara uppmärksam på när det kommer till holdingbolag.',
                },
                {
                  type: 'list-item',
                  value:
                    'Se över att det finns managementavtal med alla dotterbolag i koncernen för att inte Skatteverket ska ifrågasätt avdragsrätt i holdingbolaget.',
                },
                {
                  type: 'list-item',
                  value: 'Var uppmärksam på prissättningen.',
                },
                {
                  type: 'list-item',
                  value:
                    'För momsavdrag på kostnader vid försäljning av andelar i dotterbolag rekommenderar vi alltid utredning av momsen.',
                },
                {
                  type: 'list-item',
                  value:
                    'Ett holdingbolag kan ha blandad verksamhet och därmed delvis avdragsrätt för moms.',
                },
                {
                  type: 'list-item',
                  value:
                    'Enligt Högsta förvaltningsdomstolen 2024-03-12 (mål 3204-23) beviljades ett moderbolag momsavdrag på kostnader i samband med inköp av ett nytt dotterbolag, även om moderbolaget inte deltog i förvaltningen av det förvärvade bolaget utan i det förvärvade bolagets dotterbolag.',
                },
                {
                  type: 'list-item',
                  value:
                    // tslint:disable-next-line:max-line-length
                    'Det får inte glömmas att man måste fakturera för varor och tjänster inom koncernen för momsavdrag!',
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
